import { ACTOR_TAGS } from "@/presentation/helpers/actorTags.js";
import { scaleActionCard } from "@/presentation/prefabs/actor/actionCard/actionCardUtils.js";

/**
 * @param {Object} k - Kaplay instance
 * @param {Object} config - { cardData, handIndex }
 */
export function actionCardComposition(k, config) {
    return {
        cardData: config.cardData,
        handIndex: config.handIndex,
        isCardSelected: false,
        baseY: 0,
        isSpawning: true,

        // Lifecycle Hook - Runs as soon as k.add() is called. This solves the position.y issue.
        add() {
            this.baseY = this.pos.y;
        },

        spawn(k, targetPos, restingZ) {
            const duration = 1;

            return new Promise((resolve) => {
                k.tween(
                    k.vec2(10, targetPos.y),
                    targetPos,
                    duration,
                    (v) => (this.pos = v),
                    k.easings.easeOutSine
                ).onEnd(() => {
                    this.isSpawning = false;
                    if (this.refreshZ) this.refreshZ(restingZ);
                    resolve();
                });
            });
        },

        // Refresg the z index of the card & his children
        refreshZ(newZ) {
            this.z = newZ;
            this.get(ACTOR_TAGS.ACTION_CARD_CONTENT).forEach(child => child.z = newZ + 1);

            const halo = this.get(ACTOR_TAGS.ACTION_CARD_IS_PLAYABLE_EFFECT)[0];
            if (halo) halo.z = newZ - 1;
        },

        // Set selected state
        setSelected(isSelected) {
            this.isCardSelected = isSelected;
            const LIFT_Y = this.baseY - 60;
            const targetY = isSelected ? LIFT_Y : this.baseY;

            k.play("card_tap", { volume: 0.1 });
            k.tween(
                this.pos.y,
                targetY,
                0.2,
                (v) => { this.pos = k.vec2(this.pos.x, v) },
                isSelected ? k.easings.easeOutBack : k.easings.easeOutSine
            );

            scaleActionCard(k, this, isSelected);
        },

        // Triggers the playable effect
        setIsPlayableEffect(active) {
            const halo = this.get(ACTOR_TAGS.ACTION_CARD_IS_PLAYABLE_EFFECT)[0];

            halo.onUpdate(() => {
                if (halo.opacity > 0) {
                    halo.opacity = k.wave(0.3, 0.7, k.time() * 5);
                }
            });

            if (halo) halo.opacity = active ? 0.5 : 0;
        }
    }
}